<template>
    <v-dialog v-model="shows" max-width="900" persistent>
        <template v-slot:activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card height="100%">
            <v-card-title>
                <template v-if="isCreate">작품 생성</template>
                <template v-else>작품 상세</template>
                <v-spacer />
                <v-icon @click="shows = false">mdi-close</v-icon>
            </v-card-title>
            <v-divider />
            <v-card-text v-if="isLoaded" class="pa-0" style="max-height: calc(90vh - 120px); overflow-y: auto">
                <v-row no-gutters>
                    <v-col cols="12" sm="4">
                        <v-card-subtitle>이미지</v-card-subtitle>
                        <v-divider />
                        <v-responsive :aspect-ratio="1 / 1">
                            <v-card-text>
                                <v-tabs-items v-if="imgSrcs.length" :value="image_selected">
                                    <v-tab-item v-for="src in imgSrcs" :key="src">
                                        <v-responsive :aspect-ratio="1 / 1">
                                            <work-imgs-overlay :imgs="imgSrcs.map((url) => ({ url }))" disableLink>
                                                <template #activator="{ attrs, on, setIndex }">
                                                    <v-img :src="src" width="100%" :aspect-ratio="1 / 1" style="cursor: pointer" v-bind="attrs" v-on="on" @click="setIndex({ url: src })" />
                                                </template>
                                            </work-imgs-overlay>
                                        </v-responsive>
                                    </v-tab-item>
                                </v-tabs-items>
                                <v-img v-else :aspect-ratio="1 / 1">
                                    <v-overlay absolute z-index="0" color="grey darken-1">이미지가 없습니다</v-overlay>
                                </v-img>
                            </v-card-text>
                        </v-responsive>
                        <v-divider />
                        <v-card-actions>
                            <images-input v-model="inputs.imgs" @mouseover="setImage_selected" />
                        </v-card-actions>
                    </v-col>
                    <v-col cols="12" sm="auto">
                        <v-divider v-show="!isMobile" vertical />
                        <v-divider v-show="isMobile" />
                    </v-col>
                    <v-col>
                        <v-card-subtitle>기본 정보</v-card-subtitle>
                        <v-divider />
                        <v-card-text>
                            <v-row no-gutters>
                                <v-col class="mr-3">
                                    <v-text-field label="LOT" v-model="inputs.lot" v-bind="attrs_input" />
                                </v-col>
                                <v-col>
                                    <v-select
                                        label="작품타입"
                                        v-model="inputs.dimension.is3D"
                                        v-bind="attrs_input"
                                        :items="[
                                            { text: '평면', value: false },
                                            { text: '입체', value: true },
                                        ]"
                                    />
                                </v-col>
                            </v-row>

                            <v-row no-gutters class="my-3">
                                <v-col class="mr-3">
                                    <v-select label="작가" v-model="inputs.author" :items="authors" item-text="nameTag.ko" return-object v-bind="attrs_input" />
                                </v-col>
                                <v-col>
                                    <author-view @input="addAuthor">
                                        <template #activator="{ attrs, on }">
                                            <v-tooltip right>
                                                <template #activator="tooltip">
                                                    <v-btn text icon v-bind="{ ...attrs, ...tooltip.attrs }" v-on="{ ...on, ...tooltip.on }">
                                                        <v-icon>mdi-account-plus</v-icon>
                                                    </v-btn>
                                                </template>
                                                작가추가
                                            </v-tooltip>
                                        </template>
                                    </author-view>
                                </v-col>
                            </v-row>
                            <v-text-field label="작품명" v-model="inputs.subject" v-bind="attrs_input" class="my-3" />
                            <v-row no-gutters class="my-3">
                                <v-col class="mr-3">
                                    <v-text-field label="연도" v-model="inputs.year" v-bind="attrs_input" />
                                </v-col>
                                <v-col>
                                    <v-text-field label="재료" v-model="inputs.material" v-bind="attrs_input" />
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="my-3" align="center">
                                <template v-if="inputs.dimension.is3D">
                                    <v-col class="mr-3">
                                        <v-row no-gutters align="center">
                                            <v-col class="mr-3">
                                                <v-text-field label="가로" type="number" v-model="inputs.dimension.w" v-bind="attrs_input" class="input--text-align-right" />
                                            </v-col>
                                            <v-col class="mr-3" cols="auto">X</v-col>
                                            <v-col>
                                                <v-text-field label="세로" type="number" v-model="inputs.dimension.h" v-bind="attrs_input" class="input--text-align-right" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col>
                                        <v-row no-gutters align="center">
                                            <v-col class="mr-3" cols="auto">X</v-col>
                                            <v-col class="mr-3">
                                                <v-text-field label="높이" type="number" v-model="inputs.dimension.d" v-bind="attrs_input" class="input--text-align-right" />
                                            </v-col>
                                            <v-col>
                                                <v-select label="단위" v-model="inputs.dimension.unit" :items="['cm', 'inch']" v-bind="attrs_input" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </template>
                                <template v-else>
                                    <v-col class="mr-3">
                                        <v-row no-gutters align="center">
                                            <v-col class="mr-3">
                                                <v-text-field label="가로" type="number" v-model="inputs.dimension.w" v-bind="attrs_input" class="input--text-align-right" />
                                            </v-col>
                                            <v-col class="mr-3" cols="auto">X</v-col>
                                            <v-col>
                                                <v-text-field label="세로" type="number" v-model="inputs.dimension.h" v-bind="attrs_input" class="input--text-align-right" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col>
                                        <v-row no-gutters align="center">
                                            <v-col class="mr-3">
                                                <v-select label="단위" v-model="inputs.dimension.unit" :items="['cm', 'inch']" v-bind="attrs_input" />
                                            </v-col>
                                            <v-col>
                                                <v-text-field label="호수" type="number" v-model="inputs.dimension.code" suffix="호" v-bind="attrs_input" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </template>
                            </v-row>
                            <v-textarea label="설명" v-model="inputs.content" v-bind="attrs_input" auto-grow rows="3" />
                        </v-card-text>
                    </v-col>
                </v-row>
                <v-divider />
                <v-card-subtitle>경매 정보</v-card-subtitle>
                <v-divider />
                <v-card-text>
                    <v-row no-gutters>
                        <v-col class="mr-3">
                            <work-view-mode v-model="inputs" />
                        </v-col>
                        <v-col class="mr-3">
                            <v-select label="프로그램" v-model="inputs.program" :items="programs" item-text="subject" return-object v-bind="attrs_input" :disabled="inputs.mode_auction !== PROGRAM.value" @input="setDuration" />
                        </v-col>
                        <v-col class="mr-3">
                            <v-select label="그룹" v-model="inputs.group" :items="inputs?.program?.groups || []" :disabled="(inputs?.program?.groups || []).length < 1" v-bind="attrs_input" />
                        </v-col>
                        <v-col></v-col>
                    </v-row>
                    <v-expand-transition>
                        <v-row v-show="inputs.mode_auction == PROGRAM.value" no-gutters class="my-3">
                            <v-col class="mr-3">
                                <v-currency-field label="추정금액(최소)" prefix="KRW" v-model="inputs.price_estimated.from" v-bind="attrs_input" class="input--text-align-right" />
                            </v-col>
                            <v-col class="mr-3">
                                <v-currency-field label="추정금액(최대)" prefix="KRW" v-model="inputs.price_estimated.to" v-bind="attrs_input" class="input--text-align-right" />
                            </v-col>
                            <v-col class="mr-3">
                                <v-currency-field label="경매시작금액" prefix="KRW" v-model="inputs.price_auction.from" v-bind="attrs_input" class="input--text-align-right" />
                            </v-col>
                            <v-col>
                                <v-currency-field label="경매금액단위" prefix="KRW" v-model="inputs.price_auction.unit" v-bind="attrs_input" class="input--text-align-right" disabled />
                            </v-col>
                        </v-row>
                    </v-expand-transition>
                    <v-expand-transition>
                        <v-row no-gutters class="my-n3" v-show="inputs.mode_auction == PROGRAM.value">
                            <v-col class="mr-3">
                                <row-date-time label="경매기간-시작" v-model="inputs.duration_auction.startsAt" :attrs_input="attrs_input" />
                            </v-col>
                            <v-col>
                                <row-date-time label="경매기간-종료" v-model="inputs.duration_auction.endsAt" :attrs_input="attrs_input" />
                            </v-col>
                        </v-row>
                    </v-expand-transition>
                    <v-expand-transition> </v-expand-transition>
                </v-card-text>
                <v-divider />
                <v-card-subtitle style="position:relative">
                    상세 정보
                    <v-tooltip right>
                        <template #activator="{attrs, on}">
                            <v-btn text icon v-bind="attrs" v-on="on" @click="initClassifications" absolute class="mt-n2 ml-1">
                                <v-icon>mdi-cloud-download</v-icon>
                            </v-btn>
                        </template>
                        기본값 불러오기
                    </v-tooltip>
                </v-card-subtitle>
                <v-divider />
                <work-view-classifications v-model="inputs.classifications" />
            </v-card-text>
            <v-card-text v-else class="d-flex justify-center align-center" style="height: calc(90vh - 120px); overflow-y: auto">
                <v-progress-circular indeterminate size="100" width="5" />
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn large outlined @click="init">초기화</v-btn>
                <v-spacer />
                <v-btn large color="primary" @click="save"> 저장하기 </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import AuthorView from "./author-view.vue";
import ImagesInput from "../dumb/images-input.vue";
import RowDateTime from "../dumb/row-date-time.vue";
import WorkViewMode from "./work-view-mode.vue";
import WorkImgsOverlay from "./work-imgs-overlay.vue";
import WorkViewClassifications from "./work-view-classifications.vue";

import api from "@/api";
import detect from "@/plugins/detect";
import { getPriceUnit } from "@/plugins/getPriceUnit";
import { attrs_input, AUCTION_PROGRAM_HALLS, WORK_AUCTION_MODES } from "@/assets/variables";
const { NULL, PROGRAM } = WORK_AUCTION_MODES;

const initWork = () => ({
    imgs: [],
    author: null,
    program: null,

    lot: null,
    year: null,
    group: null,
    subject: null,
    content: null,
    material: null,
    mode_auction: NULL.value,

    dimension: {
        is3D: false,

        w: null,
        h: null,
        d: null,
        unit: null,

        code: null,
    },

    classifications: [],

    price_estimated: {
        from: null,
        to: null,
    },

    price_auction: {
        from: null,
        unit: null,
    },

    duration_auction: {
        startsAt: null,
        endsAt: null,
    },
});

export default {
    components: {
        AuthorView,
        ImagesInput,
        RowDateTime,
        WorkViewMode,
        WorkImgsOverlay,
        WorkViewClassifications,
    },
    props: {
        value: { type: Object },
    },
    data: () => ({
        PROGRAM,
        attrs_input,
        shows: false,
        isLoaded: false,
        image_selected: null,
        isMobile: detect == "mobile",

        inputs: { ...initWork() },
        authors: [],
        programs: [],
        items_hall: Object.values(AUCTION_PROGRAM_HALLS),
    }),
    computed: {
        _work() {
            return this.value?._id;
        },
        isCreate() {
            return !this._work;
        },
        imgSrcs() {
            return this.inputs.imgs.map((file) => URL.createObjectURL(file));
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
        "inputs.imgs.length"() {
            this.image_selected = this.inputs?.imgs?.length - 1;
        },
        "inputs.price_auction.from"() {
            this.inputs.price_auction.unit = getPriceUnit(+this.inputs.price_auction.from || 0) || 0;
        },
    },
    methods: {
        async init() {
            this.isLoaded = false;
            try {
                if (this.isCreate) {
                    this.inputs = { ...initWork() };
                    await this.initClassifications();
                } else {
                    const { work } = await api.console.auction.works.get({ _id: this._work });

                    if ((work.imgs || []).length > 0) work.imgs = await Promise.all(work.imgs.map(async ({ url }) => await api.getResource(url)));
                    if ((work.classifications || []).length > 0) work.classifications = work.classifications.map((item) => ({ _id: Math.random(), ...item }));

                    this.inputs = work;
                }
                [this.programs] = [(await api.console.auction.programs.gets())?.programs || []];
                [this.authors] = [(await api.console.auction.authors.gets())?.authors || []];
            } finally {
                this.isLoaded = true;
            }
        },
        async initClassifications() {
            this.inputs.classifications = (await api.console.setting.get())?.setting?.workClassifications;
        },

        validate() {},

        async save() {
            this.validate();

            const { _imgs = [], imgs = [], author = {}, program = {}, ...inputs } = this.inputs;

            // Data Fileds SET / DELETE
            inputs._author = author?._id || null;
            inputs._program = program?._id || null;
            delete inputs.bids;
            delete inputs._bids;

            // Document POST / PUT
            let work;
            if (this.isCreate) [work] = [(await api.console.auction.works.post(inputs))?.work];
            else [work] = [(await api.console.auction.works.put(inputs))?.work];

            // Files POST / PUT
            work.imgs = [];
            work._imgs = [];
            for (const _img of _imgs) {
                await api.console.auction.files.delete({ _id: _img });
            }
            for (const [index, img] of imgs.entries()) {
                const { file } = await api.console.auction.files.post({ _work: work._id, index: `imgs/${index}` }, img);

                work.imgs.push(file);
                work._imgs.push(file._id);
            }
            if (work._imgs.length) {
                [work] = [(await api.console.auction.works.put(work))?.work];
            }
            alert("저장되었습니다");

            work.author = author;
            work.program = program;
            this.$emit("input", work);

            this.shows = false;
        },

        setImage_selected(file) {
            const index = this.inputs.imgs.findIndex((img) => img == file);
            this.image_selected = index;
        },

        addAuthor(author) {
            this.authors = [author, ...(this.authors || [])];
        },
        setDuration({ duration: duration_auction } = {}) {
            this.inputs.duration_auction = duration_auction;
        },
    },
};
</script>

<style lang="scss" scoped>
.input--text-align-right ::v-deep input {
    text-align: right;
}
</style>
